import { useContext } from "react";
import { MlVectorTileLayer } from "@mapcomponents/react-maplibre";
import config from "../config";
import { DataContext } from "../context/DataContext";
import { useTheme } from "@mui/material/styles";
import { defaultTheme } from "../index";

export default function NUT2Areas() {
    const dataContext = useContext(DataContext);
    const theme = useTheme(defaultTheme);

    const layerConfigs = () => {
        return [
            {
                id: "Nut2_areas_line",
                type: "line",
                "source-layer": "nut2",
                paint: {
                    "line-color": theme.palette.layers?.NUT2Line,
                    "line-opacity": dataContext.NUT2Opacity,
                },
                layout: {
                    visibility: dataContext.NUT2Hidden ? "none" : "visible",
                },
                maxzoom: 22,
                minzoom: 4,
            },
            {
                id: "Nut2_areas_text",
                type: "symbol",
                "source-layer": "nut2",
                paint: {
                    "text-opacity": dataContext.NUT2Opacity,
                    "text-color": theme.palette.layers?.NUT2Line,
                    "text-halo-color": "#ffffff",
                    "text-halo-width": 3,
                },
                layout: {
                    "text-field": ["get", "nuts_name"],
                    "text-font": ["Klokantech Noto Sans Regular"],
                    "text-size": {
                        base: 1.2,
                        stops: [
                            [12, 18],
                            [15, 24],
                        ],
                    },
                    visibility: dataContext.NUT2Hidden ? "none" : "visible",
                },
                maxzoom: 16,
                minzoom: 6,
            },
        ];
    };
    return (
        <>
            <MlVectorTileLayer
                mapId="map_1"
                layerId="nut2_graenze"
                url={
                    config.tileServerHost +
                    "tileservergl/data/nut2/{z}/{x}/{y}.pbf?"
                }
                insertBeforeLayer="waterway-name"
                sourceOptions={{
                    attribution: "© BKG 2026 dl-de/by-2-0",
                    maxzoom: 16,
                    minzoom: 4,
                }}
                layers={layerConfigs()}
            />
        </>
    );
}
